if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super()

        this.form = this.querySelector('form')
        this.variantIdInput.disabled = false
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
        this.cart = document.querySelector('cart-drawer')
        this.submitButton = this.querySelector('[type="submit"]')
        this.submitButtonText = this.submitButton.querySelector('[data-submit-text]') || this.submitButton.querySelector('span')
        this.mirrorSubmitRow()

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog')

        this.hideErrors = this.dataset.hideErrors === 'true'
      }

      onSubmitHandler(evt) {
        evt.preventDefault()
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return

        this.handleErrorMessage()

        this.submitButton.setAttribute('aria-disabled', true)
        this.submitButton.classList.add('loading')
        const loadingSpinner = this.querySelector('.loading-spinner')
        if (loadingSpinner) loadingSpinner.classList.remove('hidden')

        document.dispatchEvent(new Event('cart:adding'))

        const config = fetchConfig('javascript')
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        delete config.headers['Content-Type']

        const formData = new FormData(this.form)
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id),
          )
          formData.append('sections_url', window.location.pathname)
          this.cart.setActiveElement(document.activeElement)
        }
        config.body = formData

        const drawerAlreadyOpen = this.cart && typeof this.cart.isOpen === 'function' && this.cart.isOpen()
        if (drawerAlreadyOpen) this.cart.showOverlay()

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              })
              this.handleErrorMessage(response.description)
              this.error = true
              return
            } else if (!this.cart) {
              window.location = window.routes.cart_url
              return
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              })
            }
            this.error = false
            const quickAddModal = this.closest('quick-add-modal')
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response)
                  })
                },
                { once: true },
              )
              quickAddModal.hide(true)
            } else {
              this.cart.renderContents(response)
            }
          })
          .catch((e) => {
            console.error(e)
            this.error = true
          })
          .finally(() => {
            this.submitButton.classList.remove('loading')
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty')
            if (!this.error) this.submitButton.removeAttribute('aria-disabled')
            const loadingSpinner = this.querySelector('.loading-spinner')
            if (loadingSpinner) {
              loadingSpinner.classList.add('hidden')
            }
            if (drawerAlreadyOpen) this.cart.hideOverlay()
            document.dispatchEvent(new Event('cart:added'))
          })
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('[role="alert"]')
        if (!this.errorMessageWrapper) return
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('span')

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled')
          if (text) this.submitButtonText.textContent = text
        } else {
          this.submitButton.removeAttribute('disabled')
          this.submitButtonText.textContent = window.variantStrings.addToCart
        }
      }

      // Second copy of the label row for the hover glide
      mirrorSubmitRow() {
        const track = this.submitButton.querySelector('.btn-cta-label-track')
        const row = track?.querySelector('[data-submit-row]')
        if (!row) return

        const mirror = row.cloneNode(true)
        mirror.setAttribute('aria-hidden', 'true')
        mirror.removeAttribute('data-submit-row')
        track.appendChild(mirror)

        const sync = () => {
          mirror.innerHTML = row.innerHTML
          mirror.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'))
        }

        sync()
        new MutationObserver(sync).observe(row, { childList: true, subtree: true, characterData: true })
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]')
      }
    },
  )
}
